<template>
  <v-row no-gutters class="pa-5" justify="center">
    <v-col class="cgu-accept" cols="2">
      <v-btn :dark="enableBtn" x-large rounded :disabled="!enableBtn" block color="#EC5785" @click="clickHandler" class="cgu-accept-button text-none">
        {{footerLabel}}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script lang='ts'>
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({})
export default class CGUFooter extends Vue {
  @Prop()
  public enableBtn: boolean | undefined;

  get footerLabel(): string {
    return this.$t('cgu.acceptation').toString();
  }

  private clickHandler() {
    this.$emit('clickBtn');
  }
}

</script>
<style lang='stylus'>
.cgu-accept {
  position relative;
}
.cgu-accept-button {
  left: 50%;
  transform translateX(-50%);
}

</style>
